export type ContentSource = "prod" | "default"

/** Read the contentSource cookie; only `prod` selects production Matrix content via UAT API. */
export function getContentSourceCookie(): ContentSource {
  if (typeof document === "undefined") {
    return "default"
  }

  const match = document.cookie.match(/(?:^|;\s*)contentSource=([^;]*)/)
  const value = match?.[1]?.trim()

  return value === "prod" ? "prod" : "default"
}

export function isProdContentSource(): boolean {
  return getContentSourceCookie() === "prod"
}

/**
 * Append ?contentSource=prod to UAT memberOnlineContent fetches when the cookie is set.
 * The UAT API switches its content cache server-side — no cross-origin prod fetch.
 */
export function buildMemberOnlineContentFetchUrl(
  baseUrl: string,
  pathSuffix = ""
): string {
  const combined = `${baseUrl}${pathSuffix}`
  if (!isProdContentSource()) {
    return combined
  }

  const separator = combined.includes("?") ? "&" : "?"
  return `${combined}${separator}contentSource=prod`
}
